import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { SuiField, SuiTab, SuiTabs, SuiContainer } from '@splashthat/sui';

import './styles.styl';

const valuePropTypes = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]);

const baseClassName = 'CustomElementTypeTabsSelector';

const StyledSuiField = styled(SuiField)`
    ${(props) => (!props.border ? 'border-color: transparent;' : '')}
`;

export default class CustomElementTypeTabsSelector extends React.Component {
    static propTypes = {
        tabs: PropTypes.arrayOf(
            PropTypes.shape({
                icon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
                label: PropTypes.string,
                value: valuePropTypes,
            }),
        ),
        value: valuePropTypes,
        border: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        qaId: PropTypes.string.isRequired,
    };

    static defaultProps = {
        tabs: [],
        value: null,
        border: true,
    };

    render() {
        const { qaId, value, tabs } = this.props;

        return (
            <StyledSuiField
                fullWidth
                className={baseClassName}
                border={this.props.border}
                formElement={
                    <SuiContainer variation="full-width" data-qa={`${qaId}--tabs`}>
                        <SuiTabs
                            noActiveBar
                            fullWidth
                            className={`${baseClassName}__tabs-container`}
                            onChange={(event, val) => this.props.onChange(val)}
                            value={value}
                            size="small"
                        >
                            {tabs.map((customTab, index) => (
                                <SuiTab
                                    iconBefore={customTab.icon}
                                    value={customTab.value}
                                    title={customTab.label}
                                    label={customTab.label}
                                    key={index}
                                    iconDirection="column"
                                />
                            ))}
                        </SuiTabs>
                    </SuiContainer>
                }
            />
        );
    }
}
